import React from 'react';
// `cn` en vez del `twMerge` genérico: este último no reconoce los tamaños del
// design system y los descarta al combinarlos con un color, que es justo lo que
// pasa cuando el color llega por `className`. Ver `@utils/cn`.
import { designSystemFontSizes, textVariants } from './types';
import type { TextProps } from './types';
import { cn } from '@utils/cn';

// ─── Component ────────────────────────────────────────────────────────────────

const Text: React.FC<TextProps> = ({
  children,
  as: Component = 'p',
  className = '',
  textColor = 'text-fg-primary',
  fontWeight,
  fontSize = 'base',
  ...props
}) => {
  // Los roles del design system ya traen el peso dentro del token de `fontSize`.
  // Emitir una clase `font-*` lo pisaría, porque Tailwind ordena el plugin
  // `fontWeight` después de `fontSize`. Por eso solo se emite cuando se pide
  // explícitamente —lo que permite sobrescribirlo a propósito— o cuando se usa
  // un tamaño de la escala genérica, donde el peso no viene incluido.
  const isDesignSystemRole = (
    designSystemFontSizes as readonly string[]
  ).includes(fontSize);

  const fontWeightClass = fontWeight
    ? textVariants.fontWeight[fontWeight]
    : isDesignSystemRole
    ? ''
    : textVariants.fontWeight.regular;

  const computedClassName = cn(
    textColor,
    fontWeightClass,
    textVariants.fontSize[fontSize],
    className,
  );

  return (
    <Component className={computedClassName} {...props}>
      {children}
    </Component>
  );
};

export { Text };
export default Text;
